import { Outlet } from 'react-router'

import { ConfigurationCommonProviders } from './ConfigurationCommonProviders'

/**
 * Initialises all the providers dependent on the current route.
 */
export const RouteProvider = () => (
  <ConfigurationCommonProviders>
    <Outlet />
  </ConfigurationCommonProviders>
)
